<template>
  <div class="rates-additional-info">
    <span
      class="ml-1 mr-1"
      v-for="(wd, i) in row.flatMap(r => r.rateData.rate.weekdays)"
      :key="i"
    >{{ wd }}<br v-if="(i + 1) % 3 === 0" /></span>
  </div>
</template>

<script>
export default {
  name: 'CalcRatesTableCellWeekdays',
  props: {
    row: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellWeekdays.vue